import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  type SxProps,
  type Theme
} from '@mui/material'
import { t } from 'ttag'

interface Authority {
  code: string
  name: string
}

interface AuthoritySelectProps {
  value: string
  onChange: (value: string) => void
  authorities: Authority[] | undefined
  error?: string
  sx?: SxProps<Theme>
}

export default function AuthoritySelect({
  value,
  onChange,
  authorities,
  error,
  sx
}: Readonly<AuthoritySelectProps>) {
  return (
    <FormControl sx={sx} required>
      <InputLabel>{t`Authority`}</InputLabel>
      <Select
        name="authority"
        error={!!error}
        required
        label={t`Authority`}
        value={value}
        onChange={e => onChange(e.target.value as string)}
      >
        {authorities?.map(({ code, name }) => (
          <MenuItem key={code} value={code}>
            {name}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText error={!!error}>{error ?? ''}</FormHelperText>
    </FormControl>
  )
}
